/**
 * @license
 *
 * Copyright IBM Corp. 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
export { default as CustomElement } from '../../components/carousel/carousel.js';
import createReactCustomElementType, {
  numberSerializer,
} from '@carbon/web-components/es/globals/wrappers/createReactCustomElementType.js';
import PropTypes from 'prop-types';
import settings from 'carbon-components/es/globals/js/settings.js';
import ddsSettings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
var prefix = settings.prefix;
var ddsPrefix = ddsSettings.stablePrefix;
export var descriptor = {
  formatStatus: {
    attribute: false,
  },
  formatAnnouncement: {
    attribute: false,
  },
  pageSize: {
    serialize: numberSerializer,
    attribute: 'page-size',
  },
  nextButtonText: {
    attribute: 'next-button-text',
  },
  prevButtonText: {
    attribute: 'prev-button-text',
  },
  start: {
    serialize: numberSerializer,
  },
  onVideoTitleUpdated: {
    event: ''.concat(ddsPrefix, '-card-cta-video-title-updated'),
  },
};
export var propTypes = {
  /**
   * The formatters for the pagination status & aria-live announcement.
   * Should be changed with the locale in which the UI is rendered.
   */
  formatStatus: PropTypes.string,
  formatAnnouncement: PropTypes.string,
  /**
   * Number of items per page.
   * If `--dds--carousel--page-size` CSS custom property is set to `<div class="bx--carousel__scroll-container">`
   * or its ancestor (e.g. the host `<dds-carousel>`), this is set automatically from `--dds--carousel--page-size`.
   */
  pageSize: PropTypes.number,
  /**
   * The assistive text for the button to go to next slide/group.
   */
  nextButtonText: PropTypes.string,
  /**
   * The assistive text for the button to go to previous slide/group.
   */
  prevButtonText: PropTypes.string,
  /**
   * The current zero-based index of the left-most card.
   */
  start: PropTypes.number,
  /**
   * The name of the custom event fired when the video title is updated
   */
  onVideoTitleUpdated: PropTypes.func,
};
const Component = createReactCustomElementType(
  ''.concat(ddsPrefix, '-carousel'),
  descriptor
);
Component.propTypes = propTypes;
export default Component;
